/**
 * User entity class
 */

/**
 * UserFactory
 * returns User entity class
 *
 * @class UserFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.User} class
 *
 * @ngdoc factory
 * @name mwApp.factory:UserFactory
 */
/* @ngInject */
export default function UserFactory (Entity, onOffMixin) {
  /* === User class === */

  /**
   * User model
   *
   * @class User
   * @classdesc User model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @return {models.User} User entity
   */
  function User () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  User.prototype = Object.create(Entity.prototype)
  User.prototype.constructor = User

  /* === User instance methods & fields === */

  Object.assign(User.prototype, {

    /**
     * instance fields
     *
     * @memberof models.User#
     * @type {Object}
     */
    _fields: {
      id: Number,
      name: String,
      email: String,
      company: String,
      currentFail: Number,
      enabled: true,
      firstName: String,
      lastLogin: String,
      lastName: String,
      location: String,
      maxFail: 3,
      password: String,
      phone: String,
      pwdChange: Boolean,
      rule: 'Rule',
      status: Boolean,
      superAdmin: Boolean,
      updatable: Boolean,
      userType: String,
    },

    /**
     * url template
     *
     * @memberof models.User#
     * @type {String}
     */
    _urlTemplate: 'api/users/{{::id}}',

    /**
     * public url template
     *
     * @memberof models.User#
     * @type {String}
     */
    _publicUrlTemplate: 'systemusers/{{::id}}',

    /**
     * Prepare entity, fill fields
     *
     * @memberof models.User#
     * @override
     */
    _prepare: function () {
      if (this.rule) {
        this.rule.superAdmin = this.superAdmin
      }
    }

  }, onOffMixin)

  /* === User static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(User, Entity)
  User._name = 'User'
  User.init()

  // permissions
  User.access = {
    view: 'viewUser',
    create: 'createUser',
    edit: 'editUser',
    delete: 'deleteUser'
  }

  return User
}
